/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WeakPasswordFeedbackParser = 
/* #__PURE__ */ parsers.object([
    ['warning', codecString],
    ['suggestions', /* #__PURE__ */ codecArray(codecString)],
]);
export class WeakPasswordFeedback extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WeakPasswordFeedbackParser.decode(input).map(res => new WeakPasswordFeedback(res));
    }
    static unsafeDecode(input) {
        return WeakPasswordFeedback.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WeakPasswordFeedbackParser.encode(data);
    }
    static schema() {
        return WeakPasswordFeedbackParser.schema();
    }
}
